// extracted by mini-css-extract-plugin
export var divider = "_1m-0";
export var dividerText = "_1m-2";
export var dividerVertical = "_1m-1";